import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';

// TypeScript interface for ZEstimate response
export interface ZEstimateResponse {
  value: {
    zestimate: string;
    zpid: string;
  };
}

export interface ZEstimateParams {
  address: string;
  cityStateZip: string;
}

export const propertyApi = createApi({
  reducerPath: 'propertyApi',
  baseQuery: waServicesQuery,
  tagTypes: ['ZEstimate'],
  endpoints: (builder) => ({
    getZEstimate: builder.query<ZEstimateResponse, ZEstimateParams>({
      query: ({ address, cityStateZip }: ZEstimateParams) => ({
        url: `/api/user/ZEstimate`,
        method: 'GET',
        params: {
          address,
          cityStateZip,
          _: Date.now().toString(), // Cache-busting timestamp
        },
      }),
      // providesTags: (_result, _error, addressString) => [
      //     { type: "ZEstimate", id: addressString },
      // ],
    }),
  }),
});

export const parseAddress = (fullAddress: string): ZEstimateParams | null => {
  // Split on comma to separate street from city/state/zip
  const parts = fullAddress.split(',');

  if (parts.length < 2) {
    return null; // Invalid format
  }

  const address = parts[0].trim();
  const cityStateZip = parts.slice(1).join(',').trim();

  return { address, cityStateZip };
};

export const { useGetZEstimateQuery, useLazyGetZEstimateQuery } = propertyApi;

export const isValidAddressForZestimate = (
  address: string | undefined,
): boolean => {
  if (!address || !address.trim()) {
    return false;
  }
  return parseAddress(address.trim()) !== null;
};
